import React from "react";
import { ComponentProps } from "../../types/components";

import { clsx } from "clsx";

/** @todo Change these keys to reflect new names e.g. primary, secondary */
const styles: any = {
  default: `text-tertiary`,
  beige: `text-tertiary`,
  light: `text-neutral h-maxi bg-neutral`,
  white: `text-white`,
  charcoal: `text-primary`,
};

export type ContentDividerProps = ComponentProps & {
  colour?: keyof typeof styles;
};

const Wrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`w-full ${className || ""}`}>{children}</div>;

const Divider = (props: any) => (
  <hr
    {...props}
    className={clsx(props.className, props.colour && styles[props.colour])}
  />
);

export const ContentDivider = ({ className, colour = "default" }) => (
  <Wrapper className={className}>
    <Divider colour={colour}></Divider>
  </Wrapper>
);
